import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { useEffect } from 'react';
import ModalPopup from '../../../ModalPopup';
import PitchCard from './PitchCard';
import './pitchGallery.css'

const PitchGallery = ({ pitch, pitches }) => {

  const navigate = useNavigate();
  const location = useLocation();
  const [modalContent, setModalContent] = useState(false);

  const handleCloseModal = () => {
    setModalContent(false);
    location.pathname.includes("/home") ?
      navigate("/home") : navigate("/projects/pitches");
  }

  const handleOpenModal = (pitch) => {
    location.pathname.includes("/home") ?
      navigate("/home/" + pitch.title) : navigate("/projects/pitches/" + pitch.title);
  }

  useEffect(() => {
    const pitchExists = () => {
      return (pitches.find(p => p.title === pitch ? p : false))
    };

    if (pitch) {
      const existingPitch = pitchExists();
      !existingPitch ? navigate("/projects/pitches") : setModalContent(existingPitch);
    }
  }, [pitches, pitch, navigate]);

  return (
    <>
      <div className="pitches-gallery">
        {pitches.map(pitch => (
          <PitchCard
            key={pitch.title}
            pitch={pitch}
            onViewMore={() => handleOpenModal(pitch)}
          />
        ))
        }
        {
          pitch && modalContent && <ModalPopup
            show={modalContent}
            handleClose={() => handleCloseModal()}
            description={modalContent.description}
            title={modalContent.title}
            image={modalContent.imgUrl}
            type={modalContent.modalContent}
            contact={modalContent.contact ? modalContent.contact : ""}
            date={modalContent.date ? modalContent.date : ""}
          />
        }
      </div>
    </>
  );
};
export default PitchGallery;
